<div class="patient-messages">
  <div class="panel-header">
    <h2 class="section-title">Messages</h2>
    @if (hasUnread()) {
      <img class="unread-mail-icon" src="https://assets.lemonaidhealth.com/web/pims/images/ic-unread-mail.svg" alt="Unread" />
    }
    <span class="spacer"></span>
    <div class="btns">
      <button class="btn btn-default" (click)="hideSystemMessages = !hideSystemMessages">
        <i class="icon" [class.ion-eye]="hideSystemMessages" [class.ion-eye-disabled]="!hideSystemMessages"></i>
      </button>
      <button class="btn btn-default" (click)="openChat()">Secure Message</button>
    </div>
  </div>

  @if (!messages().length && !isLoading()) {
    <div class="empty-state">
      <h4>No previous messages</h4>
    </div>
  }

  @if (isLoading()) {
    <div class="loading-state">Loading...</div>
  }

  <div class="messages-list">
    @for (msg of messages(); track msg.id) {
      @if (!shouldHide(msg)) {
        <messaging-message-bubble
          [message]="msg"
          [contentHtml]="(msg | messageContent).html"
          [widgets]="(msg | messageContent).widgets"
          [patientId]="patientId()"
          [senderType]="getSenderType(msg)"
        >
          @if (!msg.read && msg.from.id === patientId()) {
            <i bubble-indicator class="message-new-icon icon-new color-warning"></i>
          }
        </messaging-message-bubble>
      }
    }
  </div>
</div>
